module.exports = __webpack_public_path__ + "img/clock-white.15feae8e.svg";